var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e74w56gifa",
    x1: "66%",
    x2: "85.1%",
    y1: "43.7%",
    y2: "80.2%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EFF7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C8DAEA",
    d: "M7.077 14.826c-.56 0-.465-.212-.659-.746L4.77 8.655l12.689-7.527",
    transform: "translate(-240 -159) translate(235 152) translate(5 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9C9DD",
    d: "M7.077 14.826c.433 0 .624-.198.865-.433l2.307-2.243-2.878-1.736",
    transform: "translate(-240 -159) translate(235 152) translate(5 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e74w56gifa)",
    d: "M7.371 10.415l6.973 5.152c.796.439 1.37.211 1.568-.74l2.839-13.375C19.04.287 18.307-.24 17.545.104L.878 6.531c-1.137.456-1.13 1.091-.207 1.374L4.948 9.24l9.902-6.247c.468-.284.897-.131.545.181",
    transform: "translate(-240 -159) translate(235 152) translate(5 7)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.48b1122021bfc7e7a90e397ee1335e6d.svg";
export { ForwardRef as ReactComponent };